import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { fetchParentSubledgersLi } from "../../../services/Settings/dropdown"

/**
 * Single-select of the subledger a new subledger nests under. Only TOP-LEVEL subledgers (those with
 * no parent of their own) are offered, which keeps the nesting one level deep; the subledger being
 * edited is excluded so it cannot become its own parent. Leaving it empty makes this a top-level
 * subledger. Value = { label, value } or null.
 */
const ParentSubledgerLi = ({ control, name, placeholder, invalid, target, disabled, excludeId }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    ;(async () => {
      try {
        const res = await fetchParentSubledgersLi(excludeId)
        setOptions((res?.data || []).map(l => ({ label: l.name, value: l.id })))
      } catch (e) {
        setOptions([])
      }
    })()
  }, [excludeId])

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ref, value } }) => (
        <Select
          ref={ref}
          isClearable
          value={value || null}
          options={options}
          onChange={onChange}
          placeholder={<div className="css-placeholder">{placeholder || "Select parent subledger"}</div>}
          isDisabled={disabled}
          classNamePrefix="react-select"
          className={`elevate-dropdown${invalid ? " is-invalid" : ""}`}
          menuPortalTarget={document.querySelector(target || "body")}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          noOptionsMessage={() => "No top-level subledgers"}
        />
      )}
    />
  )
}

export default ParentSubledgerLi
